module.exports = __webpack_public_path__ + "img/dreamstime_s_156510213.c96b1837.jpg";